import redirect from "nextjs-redirect";
import React, { useEffect } from "react";

const ContactForm = () => {
  useEffect(() => {
    redirect(process.env.NEXT_PUBLIC_PRIVACY_POLICY_URL, {
      statusCode: 301,
    });
  }, []);

  return <></>;
};
ContactForm.layout = "L1";
export default ContactForm;
